<template>
  <v-menu left
          :max-width="maxWidth"
          :min-width="minWidth"
          :close-on-content-click="false"
          v-model="opened">
    <template v-slot:activator="{ on }">
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn :small="small" icon v-on="{ ...onTooltip, ...on }">
            <v-icon :small="small">
              mdi-truck-fast-outline
            </v-icon>
          </v-btn>
        </template>
        <span>Previsão de entrega do produto</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-container>
        <px-circular-loading v-if="loading"/>
        <div v-if="previsaoEntrega && !loading">
          <span class="font-weight-bold caption">Previsão de entrega em</span>
          <div :class="`${textClass}`">{{ previsaoEntrega | date }}</div>
        </div>
        <div v-if="!previsaoEntrega && !loading">
          <span :class="`${textClass}`">
            Este produto não possui uma previsão de entrega
          </span>
        </div>
      </v-container>
    </v-card>
  </v-menu>
</template>
<script>
import RequisicaoProdutoService from '@/api/requisicao-produto-service';

export default {
  props: {
    idItemRequisicao: {
      type: [String, Number],
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    textClass: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: '250px',
    },
    minWidth: {
      type: String,
      default: '200px',
    },
  },
  data() {
    return {
      opened: false,
      loading: false,
      firstSearch: false,
      previsaoEntrega: null,
    };
  },
  methods: {
    getPrevisaoEntrega() {
      this.loading = true;
      RequisicaoProdutoService.getPrevisaoEntrega(this.idItemRequisicao)
        .then(({ data }) => {
          this.previsaoEntrega = data;
          this.firstSearch = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    opened: {
      handler(newVal) {
        if (this.previsaoEntrega || this.firstSearch) {
          return;
        }
        if (newVal) {
          this.getPrevisaoEntrega();
        }
      },
    },
  },
};
</script>
